export const DETAILS_POUP_TABS = {
  GENERAL: 'general',
  INFORMATION: 'information'
};
